
const TrendsSummaryWidgets = ({ processedTrendData, currentAggregation }) => {
  if (!processedTrendData.length) return null;

  const totalRequests = processedTrendData.reduce((sum, item) => sum + item.count, 0);
  const totalSuccessful = processedTrendData.reduce((sum, item) => sum + item.successfulDiets, 0);
  const totalWarnings = processedTrendData.reduce((sum, item) => sum + item.dietsWithWarning, 0);
  const totalNoDiets = processedTrendData.reduce((sum, item) => sum + item.noDiets, 0);
  
  const avgTotal = Math.round(totalRequests / processedTrendData.length);
  const avgSuccessful = Math.round(totalSuccessful / processedTrendData.length);
  const avgWarning = Math.round(totalWarnings / processedTrendData.length);
  const avgNoDiets = Math.round(totalNoDiets / processedTrendData.length);

  const peakItem = processedTrendData.reduce((max, item) => item.count > max.count ? item : max, processedTrendData[0]);

  const periodLabel = currentAggregation === 'daily' ? 'Daily' : 
                     currentAggregation === 'weekly' ? 'Weekly' : 'Monthly';

  const peakLabel = currentAggregation === 'daily' ? 'Day' : 
                   currentAggregation === 'weekly' ? 'Week' : 'Month';

  return (
    <div className="mb-8 grid grid-cols-1 md:grid-cols-3 gap-6" data-intro="summary-stats">
      {/* Average Widget */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            {avgTotal}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            Average {periodLabel}
          </div>
          <div className="flex justify-center space-x-2">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-800 dark:text-emerald-100">
              {avgSuccessful}
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-800 dark:text-amber-100">
              {avgWarning}
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100">
              {avgNoDiets}
            </span>
          </div>
        </div>
      </div>

      {/* Peak Widget */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            {peakItem.count}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            Peak {peakLabel}
          </div>
          <div className="flex justify-center space-x-2">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-800 dark:text-emerald-100">
              {peakItem.successfulDiets}
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-800 dark:text-amber-100">
              {peakItem.dietsWithWarning}
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100">
              {peakItem.noDiets}
            </span>
          </div>
        </div>
      </div>

      {/* Total Period Widget */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            {totalRequests}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            Total Period
          </div>
          <div className="flex justify-center space-x-2">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-800 dark:text-emerald-100">
              {totalSuccessful} ({Math.round((totalSuccessful / totalRequests) * 100)}%)
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-800 dark:text-amber-100">
              {totalWarnings} ({Math.round((totalWarnings / totalRequests) * 100)}%)
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100">
              {totalNoDiets} ({Math.round((totalNoDiets / totalRequests) * 100)}%)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendsSummaryWidgets;